import { useEffect } from "react";
import styles from "./product-custom-fields.module.css";
import FormInput from "./utils/FormInput";

export default function ProductCustomFields({ product, selectedCustomAttributes = [], theme }) {
  const { customAttributes } = product;
  useEffect(() => {
    if (selectedCustomAttributes.length) {
      customAttributes?.map((attribute, index) => {
        attribute.ref.current.state.inputValue = selectedCustomAttributes[index]?.value || "";
      });
    }
  }, [selectedCustomAttributes]);

  const isThemePresent = !!theme?.backgroundColor && !!theme?.primaryColor;

  if (!customAttributes || customAttributes.length === 0) {
    return null;
  }

  return (
    <div className={styles.customFieldsGrid}>
      {customAttributes.map((attribute, index) =>
        attribute?.fields?.Required === "YES" ? (
          <FormInput
            key={attribute?.name}
            initialValue={selectedCustomAttributes[index]?.value || ""}
            ref={attribute?.ref}
            saveInLocalStorage={true}
            inputType="text"
            type="half"
            placeholder={attribute?.name}
            regex={/^(?!\s*$).+/}
            inputBgColor={isThemePresent ? undefined : "bg-appGray"}
            isInputBgSecondary={isThemePresent}
          />
        ) : (
          <FormInput
            key={attribute?.name}
            initialValue={selectedCustomAttributes[index]?.value || ""}
            ref={attribute?.ref}
            saveInLocalStorage={true}
            inputType="text"
            type="half"
            placeholder={attribute?.name}
            // errorMessage={`${attribute?.fields?.Name} can't be blank`}
            isInputBgSecondary={isThemePresent}
            inputBgColor={isThemePresent ? undefined : "bg-appGray"}
          />
        ),
      )}
    </div>
  );
}
